import { Checkbox, Input, Tree } from "antd"
import Modal from "antd/es/modal/Modal"
import '../styles.scss'
import { useEffect, useState } from "react"
interface ModalProp {
  isOpen: boolean
  sLData: any[]
  columnCode: string
  selectedValues?: (string | number)[]
  closeModal: (isClose: boolean) => void
  handleSearch: (search?: string) => void
  handleFilterColumnSelectChange: (columnCode: string, value?: (string | number)[]) => void,
}
export interface OptionSelect {
  value: number;
  title: JSX.Element;
  children: OptionSelect[]
  label: string;
  key: string

}

export const ModalTreeCar: React.FC<ModalProp> = ({
  isOpen, sLData, columnCode, selectedValues,
  closeModal,
  handleSearch,
  handleFilterColumnSelectChange
}) => {

  // function convertProvinceValueToTree(data: IprovinceChild[]) {
  //   return data.map((item) => {
  //     const treeItem: OptionSelect = {
  //       value: item.id,
  //       key: `province-${item.id}`,
  //       label: item.title,
  //       title: (
  //         <span className="text-sm font-regular text-344054">
  //           {item.title}
  //         </span>
  //       ),
  //       children: item.districts.map((district) => ({
  //         value: district.id,
  //         key: `district-${district.id}`,
  //         label: district.title,
  //         title: (
  //           <span className="text-sm font-regular text-344054">
  //             {district.title}
  //           </span>
  //         ),
  //         isLeaf: true,
  //         children: [], // ✅ Bổ sung dòng này để thỏa mãn OptionSelect
  //       })),
  //     };

  //     return treeItem;
  //   });
  // }

  const [selectedValueTmp, setSelectedValueTmp] = useState<(string | number)[]>()
  const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
  const handleConfirm = () => {
    handleFilterColumnSelectChange(columnCode, selectedValueTmp)
    closeModal(false)
  }

  useEffect(() => {
    if (isOpen) {
      setSelectedValueTmp(selectedValues)
    } else {
      setSelectedValueTmp([])
    }
  }, [isOpen])


  return (
    <Modal
      open={isOpen}
      title={false}
      footer={false}
      closeIcon={false}
      onCancel={() => closeModal(false)}

      className="w-modal-242"
    >
      <div className={`d-flex flex-column shadow-dropdown-fliter custom-ant-tree-filter`}>
        {/* <div className="p-1">
          <Input
            placeholder="Tìm kiếm "

            onChange={(e) => handleSearch(e.target.value)}
            onClear={() => handleSearch(undefined)}
            allowClear
          />
        </div> */}

        <div className={`d-flex flex-column gap-2 pl-4 py-3  ${sLData?.length >= 7 ? "h-230-px overflow-y-scroll" : ""}`}>
          <Tree
            checkable
            defaultExpandAll
            treeData={sLData}
            onCheck={(keys, info) => {
              const checkedNodes = info.checkedNodes;

              const values = checkedNodes.map((node: any) => node.value);

              setSelectedValueTmp(values);
            }}
          //  checkedKeys={dataFilterAdd.listArea}
          />
        </div>
        <div className='d-flex justify-between p-2 border-t-F0F0F0'>
          <button
            // disabled={!isAnyChecked}
            // onClick={reSetAllChecked}
            onClick={() => setSelectedValueTmp([])}
            className='border-none bg-white text-sm font-regular text-BFBFBF' >
            Làm mới
          </button>
          <button
            // onClick={() => setFilterVisible(false)}
            onClick={handleConfirm}
            className='border-none bg-096DD9 text-sm rounded-2 h-8 px-7-px font-regular text-white'>
            Xác nhận
          </button>
        </div>
      </div>

    </Modal>

  )
}
